import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import DashboardHome from './DashboardHome';
import HierarchyView from './HierarchyView';
import CustomerManagement from './CustomerManagement';
import AssetManagement from './AssetManagement';
import DeviceManagement from './DeviceManagement';
import DeviceDataView from './DeviceDataView';
import WaterDeviceDataView from './WaterDeviceDataView';
import GatewayManagement from './GatewayManagement';
import UserManagement from './UserManagement';
import AggregateRefreshJobs from './AggregateRefreshJobs';
import SystemSettings from './SystemSettings';
import ApiClientManagement from './ApiClientManagement';
import EntityDetails from './EntityDetails';
import AlertsList from './AlertsList';
import { BackfillTool } from './BackfillTool';

export default function ManagementDashboard() {
  try {
    return (
      <DashboardLayout>
        <Routes>
          <Route path="/" element={<DashboardHome />} />
          <Route path="/hierarchy" element={<HierarchyView />} />
          <Route path="/customers" element={<CustomerManagement />} />
          <Route path="/customers/:id" element={<EntityDetails type="customer" />} />
          <Route path="/assets" element={<AssetManagement />} />
          <Route path="/assets/:id" element={<EntityDetails type="asset" />} />
          <Route path="/devices" element={<DeviceManagement />} />
          <Route path="/devices/:id/energy-data" element={<DeviceDataView />} />
          <Route path="/devices/:id/water-data" element={<WaterDeviceDataView />} />
          <Route path="/devices/:id" element={<EntityDetails type="device" />} />
          <Route path="/gateways" element={<GatewayManagement />} />
          <Route path="/gateways/:id" element={<EntityDetails type="gateway" />} />
          <Route path="/users" element={<UserManagement />} />
          <Route path="/alerts" element={<AlertsList />} />
          <Route path="/backfill" element={<BackfillTool />} />
          <Route path="/refresh-jobs" element={<AggregateRefreshJobs />} />
          <Route path="/settings" element={<SystemSettings />} />
          <Route path="/api-clients" element={<ApiClientManagement />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </DashboardLayout>
    );
  } catch (error) {
    console.error('ManagementDashboard error:', error);
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Error Loading Dashboard</h1>
          <p className="text-gray-600 mb-4">
            There was an error loading the management dashboard. Please refresh the page.
          </p>
          <button 
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors"
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }
}